function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "\\uC0AC\\uAC01\\uD615 363",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h6L3 4.5z",
  "data-name": "\\uD328\\uC2A4 62",
  style: {
    fill: "#333"
  },
  transform: "translate(5 6)"
}));
export default SvgIconSelectArrow;